import { Injectable } from "@angular/core";
import { appCommonConstants } from "../../../app.constants";
import { AppAuthDataService } from "../../../services/authData.service";
import { AppEventService } from "../../../services/event.service";
import { AppLoggerService } from "../../../services/logger.service";
import { AppSignalRService } from "../../../services/signalR.service";
import { IOptimizerClientMessage } from "../interfaces/planning.interfaces";
import { appPlanningConstants } from "../planning.constants";

@Injectable({
  providedIn: 'root',
})

export class AppPlanningInitService {
  constructor(private authdata: AppAuthDataService,
    private eventService: AppEventService,
    private logger: AppLoggerService,
    private signalrService: AppSignalRService) { }

  private isInited = false;

  /** Inizializzazione */
  public init(): void {
    if (this.isInited) {
      return;
    }
    this.isInited = true;

    // All'init di SignalR, registra il client sull'evento di default tripOptimizerNotification
    this.eventService.on(appCommonConstants.events.signalR.initialized).subscribe(() => {
      this.signalrService.listenerSetUp({ name: appPlanningConstants.signalr.groups.tripOptimizerNotification, filter: false, broadcastEvent: appPlanningConstants.signalr.groups.tripOptimizerNotification }, true, true);
    });

    this.eventService.on(appPlanningConstants.signalr.groups.tripOptimizerNotification as string).subscribe((message: any) => {
      switch (message.key) {
        case appPlanningConstants.signalr.messageKey.optimizerClientMessage: {
          // Visualizzazione del messaggio solo se indirizzato/creato dall'utente loggato
          if (this.authdata.getUsername() === message.username) {
            this.logger.message(message.notifyType, { title: message.summary, message: message.message });
          }
          break;
        }

        default: {
          throw (`Chiave evento sconosciuta: ${message.key}`);
        }
      }
    });
  }
}
